var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68139 15.5868C8.73944 15.5287 8.78549 15.4598 8.81691 15.384C8.84833 15.3081 8.8645 15.2268 8.8645 15.1448C8.8645 15.0627 8.84833 14.9814 8.81691 14.9055C8.78549 14.8297 8.73944 14.7608 8.68139 14.7028L2.24539 8.26275L8.68139 1.83075C8.79861 1.71353 8.86447 1.55454 8.86447 1.38875C8.86447 1.22297 8.79861 1.06398 8.68139 0.946754C8.56416 0.829529 8.40517 0.763672 8.23939 0.763672C8.0736 0.763672 7.91461 0.829529 7.79739 0.946754L0.918386 7.82475C0.860332 7.88279 0.81428 7.9517 0.78286 8.02754C0.75144 8.10338 0.73527 8.18466 0.73527 8.26675C0.73527 8.34884 0.75144 8.43013 0.78286 8.50597C0.81428 8.58181 0.860332 8.65072 0.918386 8.70875L7.79639 15.5868C7.85444 15.645 7.92341 15.6911 7.99934 15.7226C8.07527 15.7542 8.15668 15.7704 8.23889 15.7704C8.32109 15.7704 8.4025 15.7542 8.47843 15.7226C8.55436 15.6911 8.62333 15.645 8.68139 15.5868Z",
    fill: "#7257F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.e5509e75f4d6805d56be9e89930cbd1f.svg";
export { ForwardRef as ReactComponent };